const filesPath = {
  userInfomationRequestFormPath: require("../assets/documents/แบบคำขอสิทธิ์การเข้าใช้งานระบบPDMO_PORTAL.pdf"),
  createOrganizationRequestFormPath: require("../assets/documents/CreateOrganizationRequestForm.pdf"),
  liveChatScript: require("../assets/scripts/script.js"),
  ddPlanSystemManual: require("../assets/documents/คู่มือการใช้งานระบบPDMO_PORTAL.pdf"),
};
export default filesPath;
